import { Level, LogHandler } from 'simple-logging-lib';
export class ErrorHandler extends LogHandler {
  constructor(onError) {
    super();
    this.level = Level.ERROR;
    this.isError = ({
      level
    }) => level === Level.ERROR;
    this.onError = onError;
  }
  publish(record) {
    if (this.isError(record)) {
      var _this$onError;
      const {
        loggerName,
        messages: [error]
      } = record;
      (_this$onError = this.onError) === null || _this$onError === void 0 || _this$onError.call(this, error);
      console.error('%c[%s] ', 'color:rgb(255, 0, 0);', loggerName, 'Error:', error.message, error);
    }
  }
}